import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class TpSurveySearchParams extends SearchParamsBase {
  static iconName = 'fa-solid fa-search';
  static saveType = 'TpSurveySearchParams';

  constructor(clientId) {
    super();
    this.TpSurveyID = '';
    this.BravoClientId = clientId;
    this.ThirdPartySurveyId = '';
    this.ThirdPartySurveyName = '';
    this.IsActivated = '';
  }
  initialize() {
    this.TpSurveyID = '';
    this.BravoClientId = '';
    this.ThirdPartySurveyId = '';
    this.ThirdPartySurveyName = '';
    this.IsActivated = '';
  }

  static fieldsInSearchBox = [
    // { fieldName: "BravoClientId", label: "BravoClientId", className: "col-3", type: InputTypesEnum.Number },
    { fieldName: 'TpSurveyID', label: 'TpSurveyID', className: 'col-3', type: InputTypesEnum.Number },
    { fieldName: 'ThirdPartySurveyId', label: 'Third-Party Survey Id', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'ThirdPartySurveyName', label: 'Name', className: 'col-3', type: InputTypesEnum.Text },
    { fieldName: 'IsActivated', label: 'Is Activated', className: 'col-3', type: InputTypesEnum.EmptyYesNoSelect },
  ];
}
